<template>
  <div class="bg-white sm:rounded-md sm:overflow-hidden py-6 space-y-6">
    <RadioGroup v-model="form.country">
      <RadioGroupLabel class="text-base font-medium text-gray-900">
        Select country
      </RadioGroupLabel>

      <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6">
        <RadioGroupOption
          v-for="country in countries"
          :key="country.id"
          v-slot="{ checked, active }"
          as="template"
          :value="country.id"
        >
          <div
            class="sm:col-span-3"
            :class="[checked ? 'border-transparent' : 'border-gray-300', active ? 'ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none']"
          >
            <div class="flex-1 flex">
              <div class="flex flex-col">
                <RadioGroupLabel
                  as="span"
                  class="block text-sm font-medium text-gray-900"
                >
                  {{ country.id }}
                </RadioGroupLabel>
              </div>
            </div>
            <CheckCircleIcon
              :class="[!checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']"
              aria-hidden="true"
            />
            <div
              :class="[active ? 'border' : 'border-2', checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']"
              aria-hidden="true"
            />
          </div>
        </RadioGroupOption>
      </div>
      <template v-if="form.accountOption === 'organization'">
        <div
          v-if="form.country === 'Norway'"
          class="sm:col-span-3 mb-2 mt-4"
        >
          <jet-label
            for="Org nr"
            value="Org nr"
          />
          <div class="mt-1">
            <jet-input
              id="org_no"
              v-model="form.team.org_no"
              type="text"
              class="mt-1 block w-full"
              required
              autofocus
              @keyup="searchOrg"
            />
            <p
              v-if="form.errors.org_no"
              id="org_no-error"
              class="mt-2 text-sm text-red-600"
            >
              {{ form.errors.org_no }}
            </p>
          </div>
        </div>

        <div
          v-if="searchResult.result !== null"
          class="flex items-center p-2 sm:col-span-3"
        >
          <span
            v-if="searchResult.success"
            class="flex mt-2 text-gray-800"
          >{{ searchResult.result }}</span>
          <span
            v-else
            class="flex font-bold mt-2 text-red-800"
          > {{ searchResult.result }} </span>
        </div>
        <div class="grid grid-cols-1 gap-y-2 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-3">
            <jet-label
              for="orgName"
              value="Team name"
              class="mt-2"
            />
            <jet-input
              id="orgName"
              v-model="form.team.name"
              type="text"
              class="mt-1 block w-full"
            />
          </div>
          <div class="sm:col-span-3">
            <jet-label
              for="formOrg"
              value="Org"
              class="mt-2"
            />
            <jet-input
              id="formOrg"
              v-model="form.team.org_no"
              type="text"
              class="mt-1 block w-full"
            />
          </div>
          <div class="sm:col-span-6">
            <jet-label
              for="orgAddress"
              value="Address"
              class="mt-2"
            />
            <jet-input
              id="orgAddress"
              v-model="form.team.address"
              type="text"
              class="mt-1 block w-full"
            />
          </div>
          <div class="sm:col-span-3">
            <jet-label
              for="orgZip"
              value="Zip"
              class="mt-2"
            />
            <jet-input
              id="orgZip"
              v-model="form.team.zip"
              type="text"
              class="mt-1 block w-full"
            />
          </div>
          <div class="sm:col-span-3">
            <jet-label
              for="orgCity"
              value="City"
              class="mt-2"
            />
            <jet-input
              id="orgCity"
              v-model="form.team.city"
              type="text"
              class="mt-1 block w-full"
            />
          </div>
        </div>
      </template>
    </RadioGroup>
  </div>
</template>

<script>

import {
  RadioGroup, RadioGroupLabel, RadioGroupOption,
} from '@headlessui/vue';
import { CheckCircleIcon } from '@heroicons/vue/24/solid';
import JetInput from '../../Jetstream/Input.vue';
import JetLabel from '../../Jetstream/Label.vue';

export default {
  name: 'Country',

  components: {
    JetInput,
    JetLabel,
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption,
    CheckCircleIcon,
  },

  props: ['form', 'countries'],
  emits: ['update:form'],

  data() {
    return {
      searchResult: {
        success: null,
        result: '',
      },
    };
  },

  computed: {
    form: {
      get() {
        return this.form;
      },
      set(value) {
        this.$emit('update:form', value);
      },
    },
  },

  methods: {
    searchOrg() {
      if (this.form.team.org_no.length !== 9) {
        this.searchResult.success = null;
        this.searchResult.result = '';
        this.form.team.name = '';
        this.form.team.address = '';
        this.form.team.zip = '';
        this.form.team.city = '';
      } else {
        axios.get(`https://data.brreg.no/enhetsregisteret/api/enheter/${this.form.team.org_no}`)
          .then((response) => {
            this.form.team.name = response.data.navn;
            this.form.team.address = response.data.forretningsadresse.adresse[0];
            this.form.team.zip = response.data.forretningsadresse.postnummer;
            this.form.team.city = response.data.forretningsadresse.poststed;
            this.searchResult.success = true;
            this.searchResult.result = response.data.navn;
          })
          .catch((error) => {
            if (error.response) {
              this.searchResult.success = false;
              this.searchResult.result = 'No search result';
            }
          });
      }
    },
    editTeamName() {
      const teamName = '';
      document.getElementById('orgName').value = teamName;
    },
  },
};

</script>
